import { api } from '../../../lib/api';
import type { PagedResult } from '../../administration/users/userTypes';
import {
  toQueryString,
  type RequisitionSlipListQuery,
} from '../../self-service/requisition-slips/requisitionSlipsApi';
import type {
  RequisitionSlipDetail,
  RequisitionSlipListItem,
} from '../../self-service/requisition-slips/requisitionSlipTypes';
import type { IssuedAssetLine } from './issuanceTypes';

const BASE = '/api/issuances/requests';

/**
 * Every office's requisition slips that have been SENT — Submitted or Approved — for the
 * Issuances module's Requests tab. Read-only, on `issuances.read-requests`.
 *
 * **THERE IS NO SCOPE PARAMETER.** The route fixes it server-side, exactly as the requester's
 * own client does: a Draft never comes back here, nor a refused or withdrawn slip.
 */
export const issuanceRequestsApi = {
  list: (query: RequisitionSlipListQuery, signal?: AbortSignal) =>
    api<PagedResult<RequisitionSlipListItem>>(`${BASE}${toQueryString(query)}`, { signal }),

  get: (id: string, signal?: AbortSignal) =>
    api<RequisitionSlipDetail>(`${BASE}/${id}`, { signal }),

  /** Every article released against this request — on `issuances.read`, the key of the rows. */
  issuedAssets: (id: string, signal?: AbortSignal) =>
    api<IssuedAssetLine[]>(`${BASE}/${id}/issued-assets?includeDeleted=true`, { signal }),
};
